/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {CurrencyBaseModel} from '../models/currency/currency-base.model';
import {CustomerBundleTypeConfigModel} from '../models/bundle-config/customer-bundle-type-config.model';

@Injectable({
    providedIn: 'root'
})
export class BundlesConfigService {
    public timezone: string;
    public currency: CurrencyBaseModel;
    public customerBundleTypeConfigs?: CustomerBundleTypeConfigModel[];
}
